import { render, staticRenderFns } from "./CollaboratorHabilitations.vue?vue&type=template&id=58f6da10"
import script from "./CollaboratorHabilitations.vue?vue&type=script&lang=js"
export * from "./CollaboratorHabilitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports